import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Remove from "src/components/icons/Remove";
import SignOut from "src/components/icons/SignOut";
import PowerUserTools from "src/components/PowerUserTools/Container";
import { logError } from "src/utils/logger";
import { deleteGarage, signOut } from "./data";
import { RouteComponentProps, withRouter } from "react-router";
import withFrame, { WithFrameProps } from "src/providers/frame/withFrame";

export interface GarageSettingsMenuProps {
    clearAll: () => void;
    env: string;
    onClose: () => void;
    slug: string;
    uuid: string;
}

type Props = GarageSettingsMenuProps & WithTranslation & RouteComponentProps & WithFrameProps;

class GarageSettingsMenu extends Component<Props> {
    private readonly wrapperRef: any;

    constructor(props: Props) {
        super(props);
        this.wrapperRef = React.createRef();
    }

    public componentDidMount() {
        this.props.iframe.document.addEventListener("mousedown", this.handleClickOutside);
    }

    public componentWillUnmount() {
        this.props.iframe.document.removeEventListener("mousedown", this.handleClickOutside);
    }

    public render() {
        const { t } = this.props;

        return (
            <div className="GarageSettings__menu" ref={this.wrapperRef}>
                <ul className="GarageSettings__menu--options">
                    <li data-e2e="sign-out" onClick={this.signOut}>
                        <SignOut /> {t("MyGarage.GarageHeader.GarageSettingsMenu.signOutOption")}
                    </li>
                    {this.showDelete(this.props.env) && (
                        <li data-e2e="delete-garage" onClick={this.deleteGarage}>
                            <Remove />
                            {t("MyGarage.GarageHeader.GarageSettingsMenu.deleteGarageOption")}
                        </li>
                    )}
                    <PowerUserTools />
                </ul>
            </div>
        );
    }

    private signOut = () => {
        const { clearAll, slug, env } = this.props;
        signOut(slug, env);
        clearAll();
        this.props.history.push("/");
    };

    private handleClickOutside = (event: any) => {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.props.onClose();
        }
    };

    private deleteGarage = () => {
        const { clearAll, slug, env, uuid } = this.props;
        deleteGarage(uuid, slug, env)
            .then(() => {
                clearAll();
                this.props.history.push("/");
            })
            .catch((e) => {
                logError(e);
                clearAll();
                this.props.history.push("/");
            });
    };

    private showDelete = (env: string) => {
        return env === "local" || env === "dev" || env === "demo";
    };
}

export default withTranslation()(withRouter(withFrame(GarageSettingsMenu)));
